import {
  Component,
  Input,
  Output,
  EventEmitter,
  HostListener,
  OnInit,
} from '@angular/core';

import { FormsModule } from '@angular/forms';
import { IconComponent } from '@app/shared/components/icon/icon';

@Component({
  selector: 'app-pagination',
  standalone: true,
  imports: [FormsModule, IconComponent],
  templateUrl: './pagination.html',
  styleUrls: ['./pagination.scss'],
})
export class PaginationComponent implements OnInit {
  @Input() currentPage = 1;
  @Input() totalPages = 1;
  @Input() itemsPerPage = 50;
  @Input() itemsPerPageOptions: number[] = [50, 100, 200, 500];

  @Output() pageChange = new EventEmitter<number>();
  @Output() itemsPerPageChange = new EventEmitter<number>();

  visiblePages: (number | string)[] = [];

  private displayRange = 2;

  ngOnInit(): void {
    this.updateDisplayRange();
    this.updateVisiblePages();
  }

  @HostListener('window:resize')
  onResize(): void {
    const previousRange = this.displayRange;
    this.updateDisplayRange();

    if (this.displayRange !== previousRange) {
      this.updateVisiblePages();
    }
  }

  updateDisplayRange(): void {
    const width = window.innerWidth;
    this.displayRange = width < 900 ? 1 : width > 1250 ? 3 : 2;
  }

  updateVisiblePages(): void {
    const total = this.totalPages;
    const current = this.currentPage;
    const range = this.displayRange;

    // ページ数が少ない場合はすべて表示
    if (total <= range * 2 + 3) {
      this.visiblePages = Array.from({ length: total }, (_, i) => i + 1);
      return;
    }

    const pages: (number | string)[] = [1]; // 最初のページは常に表示
    const start = Math.max(2, current - range);
    const end = Math.min(total - 1, current + range);

    if (start > 2) pages.push('…');
    for (let i = start; i <= end; i++) {
      pages.push(i);
    }
    if (end < total - 1) pages.push('…');

    pages.push(total); // 最後のページも常に表示
    this.visiblePages = pages;
  }

  changePage(page: number): void {
    if (page === this.currentPage || page < 1 || page > this.totalPages) return;
    this.currentPage = page;
    this.updateVisiblePages();
    this.pageChange.emit(page);
  }

  onItemsPerPageChange(value: number | string): void {
    const numValue = Number(value);
    if (!this.itemsPerPageOptions.includes(numValue)) return;

    this.itemsPerPage = numValue;
    this.itemsPerPageChange.emit(numValue);
  }
}
